'use client'
import { useEffect, useRef, useState } from 'react'
import Link from 'next/link'
import { GAMES } from './games'

const GlobeIcon = () => (
  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="10" cy="10" r="8" />
    <path d="M2 10h16M10 2c2.2 2.2 3.4 5.1 3.4 8s-1.2 5.8-3.4 8c-2.2-2.2-3.4-5.1-3.4-8s1.2-5.8 3.4-8z" />
  </svg>
)

export default function GamesMenu({ iconLinkClass }: { iconLinkClass: string }) {
  const [open, setOpen] = useState(false)
  const [dropdownStyle, setDropdownStyle] = useState<React.CSSProperties>({})
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function onClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onClickOutside)
    return () => document.removeEventListener('mousedown', onClickOutside)
  }, [])

  const handleToggle = () => {
    if (!open && ref.current) {
      const rect = ref.current.getBoundingClientRect()
      setDropdownStyle({ top: rect.bottom + 8, right: window.innerWidth - rect.right })
    }
    setOpen(o => !o)
  }

  return (
    <div ref={ref} className="relative">
      <button type="button" title="Games" onClick={handleToggle} className={iconLinkClass}>
        <GlobeIcon />
      </button>

      {open && (
        <div
          className="fixed flex items-center gap-1 rounded-full bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black/5 dark:ring-white/10 p-1 z-50"
          style={dropdownStyle}
        >
          {GAMES.map(({ href, title, Icon }) => (
            <Link key={href} href={href} title={title} onClick={() => setOpen(false)} className={iconLinkClass}>
              <Icon />
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
